import {
    BOARDING_STATUS_SUMMARY_FAILURE,
    BOARDING_STATUS_SUMMARY_LOAD,
    BOARDING_STATUS_SUMMARY_SUCCESS
} from './boardingStatusSummaryActions';
import { createSelector } from 'reselect';
import { get, isEqual } from 'lodash';
import { getEntityByName } from '../appEntities';

const initialState = {
    loading: false
};

export default function reducer(state = initialState, action = {}) {
    let newState;
    switch (action.type) {

        case BOARDING_STATUS_SUMMARY_LOAD:
            newState = {
                ...state,
                boardingStatusSummary: null,
                loading: true
            };

            return isEqual(state, newState) ? state : newState;

        case BOARDING_STATUS_SUMMARY_SUCCESS:
            newState = {
                ...state,
                loading: false,
                boardingStatusSummary: action.boardingStatusSummary
            };

            return isEqual(state, newState) ? state : newState;

        case BOARDING_STATUS_SUMMARY_FAILURE:
            newState = {
                ...state,
                error: action.error,
                loading: false
            };

            return isEqual(state, newState) ? state : newState;
        default:
            return state;
    }
}

export const getBoardingStatusSummaryEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'boardingStatusSummary')
);

export const getIsBoardingStatusSummaryLoading = createSelector(
    getBoardingStatusSummaryEntity,
    (entity) => get(entity, 'loading')
);

export const getBoardingStatusSummaryError = createSelector(
    getBoardingStatusSummaryEntity,
    (entity) => get(entity, 'error')
);

export const getBoardingStatusSummaryErrorMessage = createSelector(
    getBoardingStatusSummaryError,
    (error) => get(error, 'message')
);

export const getBoardingStatusSummary = createSelector(
    getBoardingStatusSummaryEntity,
    (entity) => get(entity, 'boardingStatusSummary')
);
